import {HiOutlineRefresh} from "react-icons/hi";
import {Subquestion} from "../../types";
import React from "react";
import DelayedFadeIn from "../../DelayedFadeIn";
import {useSelector} from "react-redux";
import {ChatboxSubquestionsProps} from "../types";

const BigChatboxSubquestions: React.FC<ChatboxSubquestionsProps> = ({ onQuestionRefresh, onQuestionClick }) => {

  const {
    chatSubquestions,
    chatSubquestionsLoading
  } = useSelector((state: any) => state.chatMessages);

  return (
    <DelayedFadeIn delay={400}>
      <div className="max-w-full sm:max-w-xl md:max-w-2xl lg:max-w-3xl xl:max-w-4xl mx-auto mb-4 sm:mb-6 md:mb-8">
        <div className="text-center mb-4 flex items-center justify-center gap-2 ">
          <span className="text-sm text-gray-500 dark:text-gray-400 font-medium">✨ Quick prompts to get started</span>
          <button
            type="button"
            onClick={onQuestionRefresh}
            className="] w-8 h-8 text-gray-500 dark:text-gray-400    transition-colors duration-200 disabled:opacity-50"
            title="Refresh suggestions"
            disabled={chatSubquestionsLoading}
          >
            <HiOutlineRefresh className={`w-3 h-3 sm:w-4 sm:h-4 ${chatSubquestionsLoading ? 'animate-spin' : ''}`} />
          </button>
        </div>
        <div className="flex flex-wrap gap-3 justify-center">
          {chatSubquestionsLoading ? (
            Array.from({ length: 4 }).map((_, i) => (
              <div
                key={`skeleton-${i}`}
                className="relative px-4 py-2.5 bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-blue-900/20 dark:to-indigo-900/20 hover:from-blue-100 hover:to-indigo-100 dark:hover:from-blue-900/30 dark:hover:to-indigo-900/30 border border-blue-200 dark:border-blue-800 hover:border-blue-300 dark:hover:border-blue-700 rounded-full transition-all duration-300 hover:shadow-lg hover:scale-[1.05] animate-pulse min-w-[140px] sm:min-w-[160px]"
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-2 flex-1">
                    <div className="h-3 bg-gray-300 dark:bg-gray-600 rounded-full flex-1"></div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            chatSubquestions.slice(0, 4).map((subquestion: Subquestion, index: number) => (
              <button
                key={index}
                onClick={() => onQuestionClick(subquestion.prompt)}
                className="group relative px-3 py-1.5 text-sm sm:text-base font-medium text-gray-700 dark:text-gray-200 bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-blue-900/20 dark:to-indigo-900/20 hover:from-blue-100 hover:to-indigo-100 dark:hover:from-blue-900/30 dark:hover:to-indigo-900/30 border border-blue-200 dark:border-blue-800 hover:border-blue-300 dark:hover:border-blue-700 rounded-full transition-all duration-300 hover:shadow-lg hover:scale-[1.05] transform active:scale-[0.95] whitespace-nowrap"
                title={subquestion.question}
              >
                <div className="flex items-center justify-between min-w-0">
                  <div className="flex items-center space-x-2 flex-1 min-w-0">
                    <span className="text-left text-sm truncate">
                      {subquestion.question}
                    </span>
                  </div>
                </div>
              </button>
            ))
          )}
        </div>
      </div>
    </DelayedFadeIn>
  )
};

export default BigChatboxSubquestions;